import {HTHGameConfig} from "../HTHGameConfig";
import {HTH} from "../HTH";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";

export class HTHEnhancerFrame extends PIXI.Container {
    public static fireHighlights: TimelineSprite[];
    private _fireMask: PIXI.Graphics | null;

    constructor() {
        super();
        this.name = "enhancerFrame";
        this.position = HTHGameConfig.reelAreaPos;
        HTHEnhancerFrame.fireHighlights = [];
        this.createHighlightEffect();
    }

    public assignMasks(openedEB: number): void {
        if (this._fireMask) {
            this._fireMask.destroy();
            this.removeChild(this._fireMask);
            this._fireMask = null;
        }

        this._fireMask = new PIXI.Graphics();
        this._fireMask.beginFill(0x000000, 1);
        if(openedEB===1){
            this._fireMask.drawPolygon([0,375,-30,375,-30,180,180,180,180,375,120,375,120,225,0,225,0,375]);
        }
        else if (openedEB === 2) {
            this._fireMask.drawPolygon([0, 375, -30, 375, -30, 180, 300, 180, 270, 375, 240, 375, 240, 225, 0, 225, 0, 375]);
        } else if (openedEB === 3) {
            this._fireMask.drawPolygon([0, 375, -30, 375, -30, 180, 390, 150, 390, 375, 360, 375, 360, 225, 0, 225, 0, 375]);
        } else if (openedEB === 4) {
            this._fireMask.drawPolygon([0, 375, -30, 375, -30, 150, 510, 150, 510, 375, 480, 375, 480, 225, 0, 225, 0, 375]);
        }

        this._fireMask.endFill();
        this.mask = this._fireMask;
        this.addChild(this._fireMask);
    }

    public deleteMask() {
        if (this._fireMask) {
            this.removeChild(this._fireMask);
            this._fireMask = null;
            this.mask = null;
        }
    }


    private createHighlightEffect(): void {
        for (let i: number = 0; i < 4; i++) {
            let fireHighlight = new TimelineSprite(HTH.assetLoader.getTextures("openedEBHighlight"));
            fireHighlight.name = `fireHighlight_${i + 1}`;
            fireHighlight.visible = false;
            fireHighlight.anchor.set(0.5, 0.5);
            fireHighlight.blendMode = PIXI.BLEND_MODES.ADD;
            fireHighlight.position.set(51 + (i) * HTHGameConfig.symbolWidth, 2 * HTHGameConfig.symbolHeight - 12);
            HTHEnhancerFrame.fireHighlights.push(fireHighlight);
            this.addChild(fireHighlight);
        }
        HTHEnhancerFrame.fireHighlights[0].scale.set(1, 1);
        HTHEnhancerFrame.fireHighlights[1].scale.set(1, -1);
        HTHEnhancerFrame.fireHighlights[1].position.set(171, 313);
        HTHEnhancerFrame.fireHighlights[2].scale.set(-1, 1);
        HTHEnhancerFrame.fireHighlights[2].position.set(314, 288);
        HTHEnhancerFrame.fireHighlights[3].scale.set(-1, -1);
        HTHEnhancerFrame.fireHighlights[3].position.set(433, 315);

        // this.addChild(fireHighlight);
    }

}